import * as React from 'react';
import { ComplexValue } from 'ui';
import { LoadOptions } from 'app/types-shared';
import { CodeSinglePicker } from 'app/area/codetable/common';
import { RiskMatrixIds, RiskMatrixTranslation } from 'app/area/risk-matrix-administration/constants';
import { endpoints } from 'app/area/risk-matrix-administration/endpoints';
import styles from './risk-matrix-type.scss';
export interface RiskMatrixTypeProps {
  options: ComplexValue<number>[];
  fetching: boolean;
  loadOptions: (id: string,
    componentEndpoint: string,
    loadOptionsParams: LoadOptions,
    optionsParams?: any) => void;
  value: ComplexValue<number>;
  translation: RiskMatrixTranslation;
  onChange: (value: ComplexValue<number>) => void;
}

export const RiskMatrixType = ({ loadOptions, options, value, translation, onChange, fetching }: RiskMatrixTypeProps) => {

  const onLoadOptions = (id: string, loadOptionsParams: LoadOptions) => {
    loadOptions(id,
      endpoints.types(),
      {
        ...loadOptionsParams,
        siblingId: undefined,
        levels: undefined
      });
  };

  return <CodeSinglePicker
    id={RiskMatrixIds.riskMatrixType}
    label={translation.risk_matrix_type}
    valueItem={value}
    searchRequired={false}
    required={false}
    options={options}
    fetchingOptions={fetching}
    showSpinnerLabel={false}
    translation={translation}

    onLoadOptions={onLoadOptions}
    onChange={onChange}
    size={7}
    className={styles.container}
  />;
};
